@if (!isDismissed()) {
  <div class="coverage-notification-banner" [ngClass]="backgroundClass()">
    <div class="banner-content">
      <div class="banner-content-text">
        <div class="title-row">
          @if (iconName()) {
            <iris-icon                                                            
              class="warning-icon" 
              [name]="iconName()"
              [colorToken]="isEapWarning() || isEapAlert() || isAddPaymentMethod() || isCashPay() || isCoverageUnverified() ? '$color-neutral-default' : '$color-dec-red-70'"
              [size]="iconSizes.MD">
            </iris-icon>
          }
          <div class="banner-title">
            {{ config().title }}
          </div>
        </div>

        <div class="banner-subtitle" data-test="banner-subtitle">
          {{ config().subtitle }}
          @if (config().link) {
            <a 
              class="banner-action-link"
              data-test="coverage-notification-action-link"
              (click)="config().linkClick()"
              (keydown.enter)="config().linkClick()"
              tabindex="0"
              role="button">
              {{ config().link }}
            </a>
          }
        </div>
      </div>
    
      @if (!onInsurancePage()) {
        <div class="banner-action">    
          @if (config().actionText) {
            <a 
            class="banner-action-link nowrap"
            data-test="coverage-notification-action-link"
            (click)="config().actionLinkClick()"
            (keydown.enter)="config().actionLinkClick()"
            tabindex="0"
            role="button"
            >
              {{ config().actionText }}
            </a>
          }
          @if (showDismissButton()) {
            <button 
              class="dismiss-button"
              (click)="onDismiss()"
              aria-label="Dismiss notification"
              data-test="dismiss-banner-button"
              type="button"
            >
              <iris-icon name="close" [size]="iconSizes.SM"></iris-icon>
            </button>
          }
        </div>
      }
    </div>

    @if (onInsurancePage() && (isEapWarning() || isEapAlert() || isAddPaymentMethod())) {
      <div class="banner-action-buttons">  
        <iris-button-container [alignment]="irisButtonContainerAlignments.START">
          @if (!isAddPaymentMethod()) {
            <iris-button [type]="irisButtonTypes.SECONDARY" (click)="onAddInsurance()">
              Add insurance
            </iris-button>
          }

          <iris-button [type]="irisButtonTypes.TERTIARY" (click)="onAddPaymentMethod()">
            @if (isAddPaymentMethod()) {
              Add payment method
            } @else {
              Continue with self-pay
            }
          </iris-button>
        </iris-button-container>
      </div>
    }
  </div>
}